module.exports = __webpack_public_path__ + "img/logo-light.246b3b8f.svg";